// @flow
import _ from 'lodash';
import ObjectUtils from './object';
import type { AddressType, RequestGeoType } from '../../types/address';

export default class AddressUtils {
  static toRequestGeo(address: AddressType): RequestGeoType {
    const params = _.pick(address, ['county_fips', 'state', 'region', 'zipcode']);
    return ObjectUtils.camelCaseKeys(params);
  }

  static getDiscrepancies(
    oldAddress: Object,
    newAddress: Object,
    changeKeys: Array<string>,
  ): Array<string> {
    const keysToCheck = _.isArray(changeKeys) ? changeKeys : _.keys(oldAddress);
    return _.filter(keysToCheck, key => (_.get(oldAddress, key) !== _.get(newAddress, key)));
  }

  static findGeoMatch(address: AddressType, geoArray: Array<RequestGeoType>): RequestGeoType {
    // optimally find geo with county/city that matches inputs
    const { county, city } = address;
    let match: ?RequestGeoType = null;

    if (_.isString(county)) {
      match = _.find(geoArray, geo => (
        _.isString(geo.county) && geo.county.toLowerCase() === county.toLowerCase()
      ));
    }

    if (!match && _.isString(city)) {
      match = _.find(geoArray, geo => (
        _.isString(geo.city) && geo.city.toLowerCase() === city.toLowerCase()
      ));
    }

    // fall back to first if no matches
    if (!match) match = geoArray[0];

    return match;
  }
}
